export default __webpack_public_path__ + "static/media/img-mission.9b255bbc.jpg";